import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { FormControl } from "react-bootstrap";
import { fKeyTabInput } from "../../../Utility/Utilitys";

const DetailComponent = ({
  itemDetails,
  handleDetailChange,
  fbarcodeScan,
  errors,
  vMediaQuery,
  xMediaQuery,
}) => {

  return (
    <Box mt={vMediaQuery ? 1 : xMediaQuery ? 2 : 3}>
      <Grid
        container
        columnSpacing={{ xs: 0.5, sm: 1, md: 1, lg: 1 }}
        rowSpacing={{ xs: 1.5, sm: 2, md: 2, lg: 3 }}
      >
        <Grid item xs={7} sm={6} md={3} lg={3}>
          <TextField
            label="Barcode"
            value={itemDetails?.barcode}
            fullWidth
            id="barcode"
            name="barcode"
             onChange={handleDetailChange}
            onKeyDown={fbarcodeScan}
            autoComplete="off"
            error={errors?.barcode === "" ? false : true}
            helperText={errors?.barcode}
            sx={{
              "& .MuiOutlinedInput-root": {
                paddingRight: "0px !important",
              },
              "& .MuiInputBase-input": {
                padding: "5.5px 0px 5.5px 10px !important",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={fbarcodeScan}
                    sx={{
                      "& .MuiButtonBase-root": {
                        padding: "0px !important",
                      },
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={5} sm={6} md={3} lg={2.5}>
          <TextField
            label="Item Code"
            value={itemDetails?.itemCode}
            name="itemCode"
            error={errors?.itemCode === "" ? false : true}
            helperText={errors?.itemCode}
            fullWidth
            disabled={true}
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={10} sm={10.5} md={5} lg={5.7}>
          <TextField
            value={itemDetails?.itemName}
            onChange={handleDetailChange}
            label="Item Name"
            fullWidth
            id="itemName"
            error={errors?.itemName === "" ? false : true}
            helperText={errors?.itemName}
            disabled
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={2} sm={1.5} md={1} lg={0.8}>
          <TextField
            label="Qty"
            value={itemDetails?.qty}
            fullWidth
            id="qty"
            name="qty"
            onChange={handleDetailChange}
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
            disabled
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailComponent;
